export default { 
    SET_PAYMENT_TYPE (state, val) {
        state.paymentType = val
    }
}